module.exports = __webpack_public_path__ + "img/11_l.d31099f0.jpg";